import { render, staticRenderFns } from "./BlogCardMain.vue?vue&type=template&id=c1c4d2e6"
import script from "./BlogCardMain.vue?vue&type=script&lang=js"
export * from "./BlogCardMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports